import $ from 'jquery';
import can from 'can';
import 'imports-loader?define=>false,window.jQuery=jquery!./jquery.cloudinary';
import {usgaUtils} from './usga.utils';

export const BaseModule = can.Control.extend({
	biggerMaxWidth: 1170,
	bigMaxWidth: 960,
	mediumMaxWidth: 767,
	smallMaxWidth: 480,
	resizeTimeout: 100,
	offsetVisible: 50,
	lazyLoading: true,
	domReady: false,
	loaded: false,
	hasProtectedContent: false,

	setup: function (element, options) {
		var result = this._super(element, options);
		this.$element = this.element;
		return result;
	},

	init: function () {
		this.screenSize = this.getScreenSize();
		if (this.onDocumentReady) {
			if (usgaUtils.domReady) {
				this.onDocumentReady();
			} else {
				this.on(document, 'ready', this.proxy(this.onDocumentReady));
			}
		}
		if (this.onWindowLoad) {
			if (usgaUtils.windowLoad) {
				this.onWindowLoad();
			} else {
				this.on(window, 'load', this.proxy(this.onWindowLoad));
			}
		}
		if (this.onWindowScroll || this.onFirstShow) {
			this.on(window, 'scroll', this.proxy(this._onWindowScroll));
		}
		if (this.onWindowResize || this.onLayout) {
			this.on(window, 'resize', this.proxy(this._onWindowResize));
		}
		if (this.hasProtectedContent) {
			usga.Gigya.onUser(this.proxy(this.onUserLogged));
		}
		if (this.onFirstShow) {
			if (this.lazyLoading) {
				this.checkModuleVisible();
			} else {
				this.loaded = true;
				this.onFirstShow();
			}
		} else {
			this.loaded = true;
		}
	},

	getViewportSize: function () {
		var e = window, a = 'inner';
		if (!('innerWidth' in window)) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		// Fixes CQ sim mode. Assume body explicit size can be only in pixels
		var bs = document.body.style;
		return {
			width: bs.width ? parseInt(bs.width) : e[a + 'Width'],
			height: bs.height ? parseInt(bs.height) : e[a + 'Height']
		};
	},

	getScreenSize: function () {
		var vSize = this.getViewportSize();
		var size;
		if (vSize.width <= this.smallMaxWidth) {
			size = 'small';
		} else if (vSize.width <= this.mediumMaxWidth) {
			size = 'medium';
		} else if (vSize.width <= this.bigMaxWidth) {
			size = 'big';
		} else if (vSize.width <= this.biggerMaxWidth) {
			size = 'bigger';
		} else {
			size = 'infinity';
		}
		return size;
	},

	isDomReady: function () {
		return usgaUtils.domReady;
	},

	isSmallScreen: function () {
		return (this.getScreenSize() == 'small');
	},

	isMediumScreen: function () {
		return (this.getScreenSize() == 'medium');
	},

	isBigScreen: function () {
		return (this.getScreenSize() == 'big');
	},

	isBiggerScreen: function () {
		return (this.getScreenSize() == 'bigger');
	},

	isInfinityScreen: function () {
		return (this.getScreenSize() == 'infinity');
	},

	checkModuleVisible: function () {
		var windowScrollTop = $(window).scrollTop();
		var offset = this.$element.offset();
		if (offset && (windowScrollTop + $(window).height()) >= (offset.top - this.offsetVisible)) {
			this.loaded = true;
			this.onFirstShow();
		}
	},

	applyCloudinaryConfig: function (images, cfg) {
		var config = can.extend({}, cfg);
		if (!config.quality) {
			config.quality = 70;
			if (config.width > 1200) {
				config.quality = 50;
			}
		}
		images.cloudinary(config);
	},
	trigger: function (eventName) {
		can.event.trigger.call(this, eventName, usgaUtils.getArgs(arguments, 1));
	},

	bind: function (eventName, handler) {
		can.event.bind.call(this, eventName, handler);
	},

	unbind: function (eventName, handler) {
		can.event.unbind.call(this, eventName, handler);
	},

	updateProtectedLinks: function () {
		var protectedLinks = this.element.find('a[href*=\'/protected/\'], a.protected__link');
		protectedLinks.off('click');
		if (usga.Gigya.isUserHasAccessToProtectedContent()) {
			protectedLinks.removeClass('locked').addClass('unlocked');
		} else {
			protectedLinks.removeClass('unlocked').addClass('locked');
		}
		protectedLinks.filter('.locked').click(this.proxy(this.onProtectedLinkClick));
	},

	_onWindowResize: function () {
		if (this.resizeTimer) {
			clearTimeout(this.resizeTimer);
		}
		this.resizeTimer = setTimeout(this.proxy(this.onResizeTimer), this.resizeTimeout);
	},

	onResizeTimer: function () {
		this.resizeTimer = null;
		if (this.onFirstShow && this.lazyLoading && !this.loaded) {
			this.checkModuleVisible();
		}
		var screenSize = this.getScreenSize();
		if (this.screenSize !== screenSize) {
			this.screenSize = screenSize;
			if (this.onLayout && this.loaded) {
				this.onLayout(this.screenSize);
			}
		}
		if (this.onWindowResize) {
			this.onWindowResize();
		}
	},

	_onWindowScroll: function () {
		if (this.onFirstShow && this.lazyLoading && !this.loaded) {
			this.checkModuleVisible();
		}
		if (this.onWindowScroll) {
			this.onWindowScroll();
		}
	},

	onUserLogged: function (user) {
		this.updateProtectedLinks();
	},

	onProtectedLinkClick: function (evt) {
		var $el = $(evt.currentTarget);

		evt.preventDefault();
		this.checkProtectedContentAccess();
		usga.Gigya.setRedirectionUrl($el.attr('href'));
	},

	checkProtectedContentAccess: function () {
		if (!usga.Gigya.isLoggedIn()) {
			usga.Gigya.openNotLoggedInDialog();
			usga.Gigya.setProtectedContentModalEvent('login', this.proxy(function (user) {
				if (user && !usga.Gigya.isUserHasAccessToProtectedContent()) {
					this.checkProtectedContentAccess();
				}
			}));
		} else if (!usga.Gigya.isMember()) {
			usga.Gigya.openNonMemberDialog();
		} else if (!usga.Gigya.isMembershipActualOrInGracePeriod()) {
			usga.Gigya.openMembershipExpiredDialog();
		}
	},

	/**
	 * Fixes iOS bug when keyboard moves elements that have fixed position.
	 * Accepts as arguments: form control that causes keyboard showing, overlay if page have one (else pass false) and
	 * rest as elements which position we should fix.
	 *
	 * @see https://jira.omnigon.com/browse/USGAII-3445
	 */
	iosKeyboardFixedPositionFix: function (formControl, overlay) {
		if (usgaUtils.device.ios) {
			var isActive = false,
				parents = Array.prototype.slice.call(arguments, 2),
				offsets = {},
				overlayStyles = false,
				touchMoveHandler = document.ontouchmove,
				fixPositions = function () {
					setTimeout(function () {
						var scrollTop = $(window).scrollTop();

						$.each(offsets, function (key, offset) {
							$(parents[key]).css({
								position: 'absolute',
								top: scrollTop + parseInt(offset)
							});
						});
						if (overlay) {
							if (!overlayStyles) {
								overlayStyles = $(overlay).css(['left', 'top', 'right', 'bottom', 'position', 'width', 'height']);
								overlayStyles.width = 'auto';
								overlayStyles.height = 'auto';
							}
							$(overlay).css({
								position: 'absolute',
								top: scrollTop,
								right: '',
								bottom: '',
								width: '100%',
								height: '100%'
							});
						}
						document.ontouchmove = onTouchScroll;
					}, 250);
				},
				onTouchScroll = function (event) {
					event.preventDefault();
				};

			$.each(parents, function (i, parent) {
				if ($(parent).css('position') === 'fixed') {
					var offset = $(parent).css('top');

					offsets[i] = ['auto', 'inherit'].indexOf(offset) != -1 ? 0 : parseInt(offset);
				}
			});
			this.on(formControl, 'focus', this.proxy(function () {
				isActive = true;
				fixPositions();
			}));
			this.on(formControl, 'blur', this.proxy(function () {
				document.ontouchmove = touchMoveHandler;
				isActive = false;
				$.each(offsets, function (key, offset) {
					$(parents[key]).css({
						position: 'fixed',
						top: offset
					});
				});
				if (overlay) {
					$(overlay).css(overlayStyles);
				}
			}));
			this.on(window, 'scroll', this.proxy(function () {
				if (isActive) {
					fixPositions();
				}
			}));
			this.on(window, 'resize', this.proxy(function () {
				if (isActive) {
					fixPositions();
				}
			}));
		}
	}
});


export const BaseCloudinaryModule = BaseModule.extend({

	getCloudinaryConfigParameterFromCss: function (image, name) {
		var param = image.css(name);
		if (param && param != 'auto' && param != 'none') {
			return parseInt(param.replace('px', ''));
		}
	},

	getImageAttr: function (image, name, isNumeric) {
		var val = image.attr(name);
		if (val) {
			if (isNumeric) {
				val = parseInt(val);
			}
			return val;
		}
	},

	applyCloudinary: function (container) {
		container = container || this.$element;
		var images = container.find('img[data-src]');
		var image, config, width, height, curWidth, curHeight, quality, crop;
		var dpr = window.devicePixelRatio || 1;

		for (var i = 0; i < images.length; i++) {
			image = $(images[i]);
			width = this.getCloudinaryConfigParameterFromCss(image, 'max-width');
			height = this.getCloudinaryConfigParameterFromCss(image, 'max-height');
			curWidth = this.getImageAttr(image, 'width', true);
			curHeight = this.getImageAttr(image, 'height', true);

			if ((width != curWidth) || (height != curHeight)) {
				image.removeAttr('height');
				image.removeAttr('width');
				quality = (width > 1170) ? 50 : 70;
				dpr = (width < 1170) ? dpr : null;

				config = {
					width: width,
					height: height,
					crop: this.getImageAttr(image, 'data-crop') || 'fill',
					quality: this.getImageAttr(image, 'data-quality') || quality
				};

				if (config.crop === 'fill') {
					config.gravity = 'face';
				}

				if ((width < 1170) && (dpr > 1)) {
					config.dpr = Math.ceil(dpr * 2) / 2;
				}

				image.cloudinary(config);
			}
		}
	},

	onFirstShow: function () {
		this.applyCloudinary();
	},

	onLayout: function () {
		this.applyCloudinary();
	}
});

export const VariableSlider = BaseCloudinaryModule.extend({
	autoInitialization: true,
	sliderSelector: '',

	getSliderConfig: function () {
		return {};
	},

	initSlider: function () {
		var config = this.getSliderConfig(),
			sliderElement = this.$element.find(this.sliderSelector);

		if (config) {
			this.slider = sliderElement.bxSlider(config);
			sliderElement.data('sliderInstance', this.slider);
		}
	},

	reInitSlider: function () {
		var config = this.getSliderConfig();

		if (!can.Object.same(config, this.lastConfig)) {
			this.lastConfig = config;
			if (!config && this.slider) {
				this.slider.destroySlider();
				this.slider = null;
			} else if (config && !this.slider) {
				this.initSlider();
			} else if (config && this.slider) {
				this.slider.reloadSlider(config);
			}
		}
	},

	onFirstShow: function () {
		this._super();
		this.$element.removeClass('loading');
		if (this.autoInitialization) {
			this.initSlider();
		}
	},

	onLayout: function (screen) {
		this._super();
		this.reInitSlider();
	}

});

export const Paginator = can.Map.extend({
	count: 0,
	offset: 0,
	limit: 10,

	next: function () {
		this.attr('offset', this.offset + this.limit);
	},

	prev: function () {
		this.attr('offset', this.offset - this.limit);
	},

	canNext: function () {
		return this.attr('offset') < this.attr('count') -
			this.attr('limit');
	},

	canPrev: function () {
		return this.attr('offset') > 0;
	},

	page: function (newVal) {
		if (newVal === undefined) {
			return Math.floor(this.attr('offset') / this.attr('limit')) + 1;
		} else {
			this.attr('offset', (parseInt(newVal, 10) - 1) * this.attr('limit'));
		}
	},

	pageCount: function () {
		return this.attr('count') ?
			Math.ceil(this.attr('count') / this.attr('limit')) : null;
	}
});

export const BaseModal = BaseModule.extend({

	init: function () {
		this._super();
		this.element.appendTo($('body'));
	},

	/**
	 * USGAII-3395 bug fix.
	 *
	 * @see https://jira.omnigon.com/browse/USGAII-3395
	 */
	smallScreenPositionFix: function () {
		if (this.isSmallScreen()) {
			var modal = this.element.find('.modal__body'),
				modalHeight = modal.height(),
				viewportHeight = $(window).height();

			if (modalHeight < viewportHeight) {
				modal.css('position', 'fixed');
				usgaUtils.centerElementVertically(modal);
			}
			else {
				modal.css({
					'position': 'absolute',
					'top': $(window).scrollTop() + 'px'
				});
			}
		}
	},

	open: function () {
		this.$element.show();
	},

	close: function (causedByWorkflow) {
		this.$element.hide();
		this.onClose(causedByWorkflow);
	},

	onClose: function () {
	}
});

can.Component.extend({
	tag: 'cloudinary-image',
	template: '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=" data-src="{{src}}" data-crop="{{crop}}" alt="{{alt}}">',
	scope: {
		define: {
			src: {
				set: function (value) {
					if (!value)
						return '';

					if (this.stripPrefix && value.indexOf(this.stripPrefix) === 0) {
						value = value.substr(this.stripPrefix.length);
					}
					return value;
				}
			}
		},
		stripPrefix: '/content/dam'
	}
});
